import { CmsEncyclopediaCategory } from 'types/cms/collection-types'
import { Language } from 'types/language'

export type CategoryCardProps = {
  category: CmsEncyclopediaCategory
  language: Language
}

export enum Animations {
  HOUSE = 'house',
  BROCCOLI = 'broccoli',
  SOLAR_PANEL = 'solarPanel'
}
